import React, { Component } from "react";
import classNames from "classnames";
//import IconCart from "ReactComponents/Shared/Icons/icon-cart";
import { basketComposer } from "ReactReducers/Basket/basket-composer";
import { Breakpoints } from "ReactComponents/Shared/Constants/breakpoints";
import AmountInput from "ReactComponents/Shared/FormInputs/amount-input";
import IconCart from "ReactComponents/Shared/Icons/icon-cart";

class BasketAdd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            value: 1,
            min: parseInt(this.props.min) || 1,
            max: parseInt(this.props.max) || 9999,
            isMaxCat: null,
            isTouchMaxHorse: null
        };

        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.close = this.close.bind(this);
        this.keyDown = this.keyDown.bind(this);
        this.onResize = this.onResize.bind(this);
        this.addToBasket = this.addToBasket.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.onResize);
        this.onResize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }

    onResize() {
        if (global.canUseDOM) {
            this.setState({
                isMaxCat: window.matchMedia(
                    this.props.maxCatMediaQuery ??
                        `(max-width: ${Breakpoints.lion}px), (min-width: ${Breakpoints.rhino + 15}px)`
                ).matches,
                isTouchMaxHorse:
                    window.matchMedia(`(max-width: ${Breakpoints.horse}px)`).matches &&
                    "ontouchstart" in window
            });
        }
    }

    onFocus() {
        if (this.state.isTouchMaxHorse || this.state.isOpen) return;

        if (global.canUseDOM) {
            document.addEventListener("click", this.close);
            document.addEventListener("keydown", this.keyDown);
        }

        this.setState({
            isOpen: true
        });
    }

    onBlur(e) {
        this.close(e);
        if (!this.state.isTouchMaxHorse) return;

        this.setState({
            value: this.state.value.length == 0 || this.state.value == 0 ? this.state.min : this.state.value
        });
    }

    onChange(e) {
        if (isNaN(e.target.value)) return;

        this.setState({
            value: e.target.value
        });
    }

    keyDown(e) {
        if (e.keyCode === 27 || e.keyCode == 13) {
            this.addToBasket();
            this.close(e, true);
        } else if (e.keyCode === 38) {
            this.increment();
        } else if (e.keyCode === 40) {
            this.decrement();
        }
    }

    close(e, force) {
        if (!this.isDescendant(this.refs.input, e.target) || force) {
            if (global.canUseDOM) {
                document.removeEventListener("click", this.close);
                document.removeEventListener("keydown", this.keyDown);
            }

            this.setState({
                isOpen: false,
                value:
                    this.state.value.length == 0 || this.state.value == 0 ? this.state.min : this.state.value
            });

            e.target.blur();
        }
    }

    increment() {
        if (this.state.value >= this.state.max) return;

        this.setState({
            value: this.state.value ? parseInt(this.state.value) + 1 : this.state.min
        });

        this.setFocus();
    }

    decrement() {
        if (this.state.value <= this.state.min) return;

        this.setState({
            value: this.state.value ? parseInt(this.state.value) - 1 : this.state.min
        });

        this.setFocus();
    }

    setFocus() {
        this.refs.inputField.focus();

        if (!this.state.isTouchMaxHorse) {
            requestAnimationFrame(() => {
                if (!this.refs.inputField) return;
            });
        }
    }

    isDescendant(parent, child) {
        var node = child.parentNode;

        while (node != null) {
            if (node == parent) {
                return true;
            }
            node = node.parentNode;
        }

        return false;
    }

    addToBasket() {
        this.props.add({
            Id: this.props.id,
            amount: this.state.value,
            product: this.props.product,
            AddCountToExistingBasket: true
        });
    }

    isLoading() {
        return this.props.isAdding.indexOf(this.props.id) != -1;
    }

    render() {
        const btnHasLabel = this.state.isMaxCat && this.props.label;
        const rootClasses = classNames("add-to-basket", {
            "add-to-basket__is-open": this.state.isOpen,
            "add-to-basket__hasLabel": btnHasLabel
        });

        return (
            <div className={rootClasses}>
                <AmountInput
                    context={this.props.product.Title}
                    value={this.state.value}
                    onChange={this.onChange}
                />

                <button
                    type="button"
                    className="add-to-basket__button"
                    disabled={this.isLoading()}
                    onClick={this.addToBasket}
                    aria-label={`Læg ${this.state.value} stk. ${this.props.product.Title} i kurv`}
                >
                    {!this.isLoading() ? (
                        btnHasLabel ? (
                            this.props.label
                        ) : (
                            <IconCart />
                        )
                    ) : (
                        <div className="loader">
                            <span></span>
                        </div>
                    )}
                </button>
            </div>
        );
    }
}

export default basketComposer(BasketAdd);
